<template lang="pug">
v-form(ref="form")
  v-row(no-gutters)
    v-col(:cols="blast.enabled ? 12 : 7")
      v-card.rounded-lg.content-box.pa-6(outlined)
        v-row
          v-col(:cols="blast.enabled ? 7 : 12")
            v-row(no-gutters align="center")
              v-col.grow
                div.d-flex.align-center
                  .text-md.font-semibold SMS delivery
                  y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
              v-col.shrink(v-if="blastData && blast.enabled && offer.status !== 'draft'")
                y-button.mr-3(label="Deliverance details" outlined size="xxs" @click="showDeliveranceDetailsDialog = true")
              v-col.shrink
                y-switch.mb-n3(v-model="blast.enabled")

            v-row.my-4(v-if="blast.enabled")
              v-divider.neutral300

            template(v-if="blast.enabled")
              //- Sender ID
              div.text-md.font-semibold.neutral700--text Sender ID
              v-text-field.text-sm.mt-2.round-xl(v-model="senderID" placeholder="Sender ID" outlined dense disabled height="48" readonly :loading="isFetching" hide-details="auto")
                template(v-slot:append)
                  v-btn.button-sm(outlined style="margin-top: -2px" @click.stop="handleRedirectSenderId") Edit
              //- Offer message
              div.text-md.font-semibold.neutral700--text.mt-5 Offer message
              v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" :prefix="senderIDPrefix" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
              div.text-sm.font-normal.neutral700--text.text-right.mt-1 Character Count {{contentLength.length}} | SMS Count {{contentLength.numSMS}} | Cost RM {{contentLength.cost.toFixed(2)}} per recipient
              template(v-if="offer.redeem_method != 'show_message'")
                div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
                v-chip.mt-1.mr-1(v-if="offer.end_at" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                  span.neutral700--text Expiry date
                v-chip.mt-1.mr-1(link small outlined color="neutral400" @click="insertValue('offer_code')")
                  span.neutral700--text Redemption code
                v-chip.mt-1(v-if="hasSmsHeader" link small outlined color="neutral400" @click="insertValue('brand_name')")
                  span.neutral700--text Brand name (Sender ID)
              //- Send offer
              div.text-sm.font-medium.neutral700--text.mt-5 Send this offer:
              v-card.round-xl.mt-2.pa-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                v-radio-group.mt-0(v-model="blast.send_cue" hide-details)
                  v-radio(value="offer_activated" color="neutral700")
                    template(v-slot:label)
                      div.text-sm.font-medium.neutral700--text Immediately after this offer is created
                  v-radio(value="scheduled" color="neutral700" style="align-items: unset;")
                    template(v-slot:label)
                      div.text-sm.font-medium.neutral700--text Later on:
                  template(v-if="blast.send_cue && blast.send_cue === 'scheduled'")
                    div.ml-8.mt-4
                      v-row(dense)
                        v-col.grow
                          div.text-sm.font-semibold.neutral500--text Date
                        v-col.grow
                          div.text-sm.font-semibold.neutral500--text Time
                        v-col.shrink
                          div.pl-7
                      template(v-for="(schedule, index) in schedules")
                        v-row(dense :key="`sch-${index}`")
                          v-col.grow
                            date-picker-field(v-model="schedule.date" :min="getTodayDate()" required :disabled="schedules.length && schedules.length !== (index + 1)")
                          v-col.grow
                            v-text-field.text-sm.round-xl(v-model="schedule.time" outlined dense height="48" :rules="rules.not_empty" type="time" :background-color="schedules.length && schedules.length !== (index + 1) ? '' : 'neutral100'" :disabled="schedules.length && schedules.length !== (index + 1)" hide-details="auto")
                          v-col.shrink
                            v-btn.mt-2(v-if="index && schedules.length === (index + 1)" icon small @click="deleteSchedule()")
                            v-btn.mt-2(v-if="index && schedules.length === (index + 1)" icon small @click="deleteSchedule()")
                              v-icon $yzi-trash-03
                            div.pl-7(v-else)
                      y-button.mt-3(label="Add more" prepend-icon="$yzi-plus" size="sm" @click="schedules.push({ time: '00:00' })")

          v-divider.neutral300.my-n3(v-if="blast.enabled" vertical)
          //- SMS preview
          v-col.pt-0(v-if="blast.enabled" cols="5")
            sms-preview(title="Offer message preview" :sender="senderIDPrefix" :content="blast.content")

  .dialogs
    deliverance-details-dialog(v-if="showDeliveranceDetailsDialog" :open.sync="showDeliveranceDetailsDialog" :blast-data="blastData")

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {DateTime} from 'luxon'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import SmsPreview from '@/components/clinic/marketing/SmsPreview.vue'
import DeliveranceDetailsDialog from '@/components/clinic/marketing/dialogs/DeliveranceDetailsDialog.vue'

export default {
  components: { DatePickerField, SmsPreview, DeliveranceDetailsDialog },
  props: {
    blastData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isFetching: false,
      showDeliveranceDetailsDialog: false,
      cursorPosition: 0,
      blast: {
        name:  'Offer message',
        send_cue: 'offer_activated',
        type: 'offer',
        method: 'sms',
        enabled: true,
        content: 'Here\'s your offer! Visit us and show this SMS to redeem. Code: {{ offer_code }}. Expires on {{ expiry_date }}.'
      },
      schedules: [{ time: '00:00' }],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer',
      setting: 'marketing/getMarketingSettings'
    }),
    hasSmsHeader () {
      return this.setting && this.setting.sms_header
    },
    senderID () {
      let text = null
      if (this.hasSmsHeader) {
        text = `RM0 ${this.setting.sms_header}`
      }
      return text
    },
    senderIDPrefix () {
      return `${this.senderID}: `
    },
    contentLength() {
      let text = this.blast?.content || ''
      text = text + this.senderIDPrefix
      text = text.replace(/{{ offer_code }}/g, this.replaceCodeValue)
      text = text.replace(/{{ expiry_date }}/g, this.replaceExpiryDataValue)
      text = text.replace(/{{ brand_name }}/g, this.replaceBrandNameValue)
      const length = text ? text.length : 0;
      const charLength = 155
      const numSMS = Math.ceil(length / charLength);
      const cost = numSMS * 0.15
      return { length, numSMS, cost };
    },
    textarea () {
      return this.$refs.textarea.$el.querySelector('textarea')
    },
    replaceCodeValue () {
      if (this.offer.redeem_method === 'unique_code') return 'CODE'
      if (this.offer.redeem_method === 'general_code') return this.offer.coupon_code
      return ''
    },
    replaceExpiryDataValue () {
      if (this.offer.end_at) return this.$options.filters.displayDate(this.offer.end_at)
      return ''
    },
    replaceBrandNameValue () {
      if (this.hasSmsHeader) return this.setting.sms_header
      return ''
    }
  },
  watch: {
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.schedules.length) {
          this.schedules = blast.schedules.map(schedue => {
            return {
              date: DateTime.fromISO(schedue.scheduled_for).toFormat('yyyy-MM-dd'),
              time: DateTime.fromISO(schedue.scheduled_for).toFormat('HH:mm')
            }
          })
        }
        this.blast = blast
      }
    },
    updateCursor () {
      const position = this.textarea.selectionStart
      if (!position) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    deleteSchedule () {
      this.schedules.pop()
    },
    validateData () {
      return this.$refs.form.validate()
    },
    saveData () {
      if (!this.validateData()) {
        return
      }
      const payload = this.getPayload()
      if (this.blast.id) {
        return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
      }
      return this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
    },
    getTodayDate () {
      return DateTime.local().toFormat('yyyy-MM-dd')
    },
    handleRedirectSenderId() {
      this.$router.push('/admin/clinic/settings/marketing')
    },
    getPayload () {
      if (!this.blastData && !this.blast.enabled) {
        return {
          name: this.blast.name,
          method: this.blast.method,
          type: this.blast.type,
          send_cue: this.blast.send_cue,
          content: this.blast.content,
          enabled: false,
        }
      }
      if (!this.blast.enabled) {
        return {
          enabled: false
        }
      }
      let payload = {
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        content: this.blast.content,
        send_cue: this.blast.send_cue,
        schedules: [],
        enabled: this.blast.enabled
      }
      if (payload.send_cue === 'scheduled') {
        payload.schedules = this.schedules.map(m => {
          return `${m.date} ${m.time}`
        })
      }
      return payload
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>